export const mainOptionsList = [
    {
        type : "number",
        dataInputName : "length",
        optionName : "Länge:"
    },
    {
        type : "number",
        dataInputName : "width",
        optionName : "Breite:"
    },
    {
        type : "number",
        dataInputName : "height",
        optionName : "Höhe:"
    },
    {
        type : "number",
        dataInputName : "wallWidth",
        optionName : "Wandstärke:"
    }
];

export const additionalOptionsList = [
    "A15",
    "B125",
    "D400",
    "E600",
    "Unterflur"
];


// WEBPACK FOOTER //
// ./src/containers/steps/step1/OptionArea/OptionsList.js